import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import Bar from "../../assets/image/auto/timelinebar.png";
// import Kakao from "../../assets/image/sns/kakao.png";
// import Feed from "../../assets/image/sns/feed.png";
// import Story from "../../assets/image/sns/story.png";
// import blog from "../../assets/image/sns/blog.png";
// import band from "../../assets/image/sns/band.png";
// import axios from "axios";
import useStrictBackBlock from "../../bridges/useStrictBackBlock";
import { HeaderIconL } from "../../assets/components/HeaderGroup";
import home from "../../assets/icons/System/close.svg";
import { FillButton } from "../../assets/components/ButtonGroup";

const ageNameMap = {
    "10": "10대",
    "20": "20대",
    "30": "30대",
    "40": "40대",
    "50": "50대",
    "60": "60대 이상"
}
const channelNameMap = {
    "1": "카카오톡",
    "2": "인스타 스토리",
    "3": "인스타 게시물",
    "4": "네이버 블로그",
    "6": "네이버 밴드"
};

const titleNameMap = {
    "1": "매장 홍보",
    "2": "상품 소개",
    "3": "이벤트",
};

const ManualMarketingFinal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { image, selections, instaText, storeBusinessNumber } = location.state || {};

    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const [headerSpace, setHeaderSpace] = useState(0);
    const [bottomSpace, setBottomSpace] = useState(0);

    useEffect(() => {
        const updateSpace = () => {
            if (headerRef.current && footerRef.current) {
                setHeaderSpace(headerRef.current.offsetHeight)
                setBottomSpace(footerRef.current.offsetHeight);
            }
        };

        updateSpace();
        window.addEventListener("resize", updateSpace);
        return () => window.removeEventListener("resize", updateSpace);
    }, []);

    const ageName = ageNameMap[selections?.age] || "나이"
    const channelName = channelNameMap[selections?.channel] || "채널";
    const titleName = titleNameMap[selections?.title] || "주제";

    //메뉴얼용
    const getFormattedDate = () => {
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const date = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        return {
            fullDate: `${year}-${month}-${date} ${hours}:${minutes}`, // 전체 문자열
            onlyDate: `${year}.${month}.${date}`, // 날짜만
            onlyTime: `${hours}:${minutes}`      // 시간만
        };
    };

    const { onlyDate: ManualDate } = getFormattedDate();
    // const manualDateRange = [onlyDate, onlyDate]

    // const onSave = async () => {
    //     const userId = localStorage.getItem("user_id")
    //     const data = {
    //         title: selections.title,
    //         age: selections.age,
    //         style: selections.style + "",
    //         channel: selections.channel,
    //         repeat: "없음",
    //         date_range: manualDateRange,
    //         upload_time: ManualTime,
    //         alert_check: false,
    //         user_id: userId,
    //         image: image,
    //         type: type,
    //     }

    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/auto/app/save`,
    //             data,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                 },
    //             }
    //         );
    //         if (response.data.success) {
    //             navigate(`/ads/main`, { state: { storeBusinessNumber } });
    //         }
    //     } catch (error) {
    //         console.error("요청 실패:", error);
    //         alert("저장 오류")
    //     }
    // }

    const returnHome = () => {
        navigate("/ads/main", { state: { storeBusinessNumber } });
    }

    useStrictBackBlock(true);

    return (
        <div>
            <div
                ref={headerRef}
                className="fixed top-0 left-0 right-0 z-10">
                <HeaderIconL
                    title=""
                    icon={home}
                    onIconClick={returnHome}
                />
            </div>

            <div
                className="p-[16px]"
                style={{ paddingTop: headerSpace, paddingBottom: bottomSpace }}
            >
                <div className="flex flex-col pt-[16px] gap-[8px]">
                    <h2 className="text-t2 text-text-default">포스팅을 완료했어요✨</h2>
                    <p className="text-b2 text-text-subtler">다른 스타일의 이미지도 생성해 보세요.</p>
                </div>

                <div className="flex flex-row items-start rounded-xl py-[24px]">
                    <div className="flex-1 rounded-xl">
                        <div className="px-2">
                            {image && (
                                <img
                                    src={image}
                                    alt="AI 생성 이미지"
                                    className="rounded-xl object-cover w-[80%] mx-auto"
                                />
                            )}
                        </div>

                        {instaText && (
                            <div className="flex flex-col">
                                <p className="pt-[16px] text-t4 text-center">포스팅한 게시글</p>
                                <p className="text-c2 text-text-subtler whitespace-pre-line">
                                    {instaText}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="inline-grid w-full grid-cols-2 rounded-[12px] bg-surface-light-subtle text-text-subtle overflow-hidden border border-border-subtle">
                    <div className="flex flex-col items-center justify-center py-[12px] border-b border-r border-border-subtle">
                        <span className="pb-[4px] text-c3 text-text-subtler">포스팅 날짜</span>
                        <span className="text-c1 text-text-subtle">{ManualDate}</span>
                    </div>
                    <div className="flex flex-col items-center justify-center py-[12px] border-b border-border-subtle">
                        <span className="pb-[4px] text-c3 text-text-subtler">홍보 채널</span>
                        <span className="text-c1 text-text-subtle">{channelName}</span>
                    </div>

                    {/* 2행 */}
                    <div className="flex flex-col items-center justify-center py-[12px] border-r border-border-subtle">
                        <span className="pb-[4px] text-c3 text-text-subtler">홍보 고객</span>
                        <span className="text-c1 text-text-subtle">{ageName}</span>
                    </div>
                    <div className="flex flex-col items-center justify-center py-[12px]">
                        <span className="pb-[4px] text-c3 text-text-subtler">맞춤 주제</span>
                        <span className="text-c1 text-text-subtle">{titleName}</span>
                    </div>
                </div>
            </div>

            {/* 하단 고정 버튼 (스크롤 영향 X) */}
            <div ref={footerRef} className="fixed bottom-0 left-0 right-0 z-10">
                <FillButton onClick={returnHome}>홈 화면으로</FillButton>
            </div>
        </div>
    );
};

export default ManualMarketingFinal;
